import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SR_API_ACTION_LISTING_WANTS_TO_APPLY } from 'api/actionTypes';

import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';

@withApiState({
  agentSubmitWantsToApplyApiState: {
    action: SR_API_ACTION_LISTING_WANTS_TO_APPLY,
  },
})
class SrAgentWantsToApplyButton extends Component {
  static propTypes = {
    userId: PropTypes.number.isRequired,
    listingId: PropTypes.number.isRequired,
    showing: PropTypes.object.isRequired,
    agentSubmitWantsToApplyApiState: PropTypes.object.isRequired,
    onWantsToApply: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  _onWantsToApplyClick = ({ userId, listingId, wantsToApply }) => {
    const { dispatch, onWantsToApply } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_LISTING_WANTS_TO_APPLY,
      queryId: `${userId}-${listingId}`,
      payload: {
        userId: userId,
        listingId: listingId,
        wantsToApply: wantsToApply,
      },
    }).then(() => {
      if (onWantsToApply) {
        onWantsToApply(wantsToApply);
      }
    });
  };

  render() {
    const { userId, listingId, showing, disabled, agentSubmitWantsToApplyApiState } = this.props;

    return (
      <button
        name="agentWantsToApply"
        className={classnames(
          'button blue',
          // TODO: Enable toggle "wants to apply", if we remove 'disabled' the button doesn't look active anymore.
          showing.wantsToApply && 'disabled',
        )}
        type="button"
        onClick={() =>
          this._onWantsToApplyClick({
            userId: userId,
            listingId: listingId,
            wantsToApply: !showing.wantsToApply,
          })
        }
        disabled={disabled}
      >
        {agentSubmitWantsToApplyApiState.inProgress ? 'loading...' : 'wants to apply'}
      </button>
    );
  }
}

SrAgentWantsToApplyButton.displayName = 'SrAgentWantsToApplyButton';

export default SrAgentWantsToApplyButton;
